<template>
    <div>
        <h5>All Existing Departments</h5>
        <!-- Use of custom tree table for Department -->
        <custom-tree-table
            :treeTableValue="departmentTreeTable"
            entity="Department"
            @editOperation="editDepartment"
            @deleteOperation="departmentStore.deleteDepartment"
            @manageManager="openManagerDialog"
        />

        <!-- Department edit form -->
        <department-form v-if="editDialogForm" @hide-dialog="editDialogForm = false" />

        <!-- Department manager dialog -->
        <department-manager-dialog
            v-if="managerDialogVisible"
            :departmentId="selectedDepartment.id"
            :managers="selectedDepartment.managers || []"
            @hide-dialog="managerDialogVisible = false"
            @refresh="loadDepartments"
        />
    </div>
</template>

<script setup>
import CustomTreeTable from '../../../components/CustomTreeTable.vue';
import DepartmentForm from './DepartmentForm.vue';
import DepartmentManagerDialog from './DepartmentManagerDialog.vue';
import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';
import { departmentStore } from '../../../../../store/global-stores';

const { departmentTreeTable } = storeToRefs(departmentStore);
const editDialogForm = ref(false);
const managerDialogVisible = ref(false);
const selectedDepartment = ref({ id: null, managers: [] });

onMounted(() => {
    loadDepartments();
});

const loadDepartments = async () => {
    await departmentStore.fetchAllDepartments();
};

const editDepartment = (department) => {
    departmentStore.createEditDepartmentBody(department);
    editDialogForm.value = true;
};

const openManagerDialog = (node) => {
    selectedDepartment.value = {
        id: node.key,
        managers: node.data?.managers || [],
    };
    managerDialogVisible.value = true;
};
</script>
